import { render, staticRenderFns } from "./ColorPickerFlat.vue?vue&type=template&id=7d6bdf16"
import script from "./ColorPickerFlat.vue?vue&type=script&lang=js"
export * from "./ColorPickerFlat.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerFlat.vue?vue&type=style&index=0&id=7d6bdf16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports